@if (storeService.isDeliveryPickupPointPosible()) {
<form [formGroup]="pointForm" (keydown.enter)="$event.preventDefault()">
  <div
    class="fdx-o-grid__row fdx-o-grid__row--center fdx-u-mb--10 fdx-u-mt--10">
    <div class="fdx-o-grid__item--11 fdx-o-grid__item--12@medium">
      <div class="fdx-o-grid__row fdx-o-grid__row--guttered-small">
        <app-form-input-control
          class="fdx-o-grid__item--12"
          [formField]="name"
          [labelName]="'Nazwa kontaktu *'">
          <input
            type="text"
            class="fdx-c-form-group__input fdx-u-px--4"
            id="name"
            formControlName="name"
            [maxLength]="150" />
        </app-form-input-control>

        <app-form-input-control
          class="fdx-o-grid__item--12"
          [formField]="company"
          [labelName]="'Firma'">
          <input
            type="text"
            class="fdx-c-form-group__input fdx-u-px--4"
            id="company"
            formControlName="company"
            [maxLength]="150" />
        </app-form-input-control>

        <app-form-input-control
          class="fdx-o-grid__item--6"
          [formField]="zipCode"
          [labelName]="'Kod pocztowy *'">
          <input
            type="text"
            class="fdx-c-form-group__input fdx-u-px--4"
            id="zip_code"
            formControlName="zip_code"
            pattern="^[0-9]{2}-[0-9]{3}$"
            maxlength="6"
            (input)="this.formService.formatZipCode($event)" />
        </app-form-input-control>

        <app-form-input-control
          class="fdx-o-grid__item--6"
          [formField]="city"
          [labelName]="'Miejscowość *'">
          <input
            type="text"
            class="fdx-c-form-group__input fdx-u-px--4"
            id="city"
            formControlName="city"
            [maxLength]="85" />
        </app-form-input-control>

        <app-form-input-control
          class="fdx-o-grid__item--6"
          [formField]="street"
          [labelName]="'Ulica *'">
          <input
            type="text"
            class="fdx-c-form-group__input fdx-u-px--4"
            id="street"
            formControlName="street"
            [maxLength]="70" />
        </app-form-input-control>

        <app-form-input-control
          class="fdx-o-grid__item--3"
          [formField]="street"
          [labelName]="'Nr Domu *'">
          <input
            type="text"
            class="fdx-c-form-group__input fdx-u-px--4"
            id="house_number"
            formControlName="house_number" />
        </app-form-input-control>

        <app-form-input-control
          class="fdx-o-grid__item--3"
          [formField]="apartmentNumber"
          [labelName]="'Nr lokalu'">
          <input
            type="text"
            class="fdx-c-form-group__input fdx-u-px--4"
            id="apartment_number"
            formControlName="apartment_number" />
        </app-form-input-control>

        <app-form-input-control
          class="fdx-o-grid__item--6"
          [formField]="phone"
          [labelName]="'Telefon kontaktowy *'">
          <input
            type="text"
            class="fdx-c-form-group__input fdx-u-px--4"
            id="phone"
            formControlName="phone"
            (input)="
              this.formService.onInputForNumberField2(
                $event,
                pointForm.get('phone')
              )
            " />
        </app-form-input-control>

        <app-form-input-control
          class="fdx-o-grid__item--6"
          [formField]="email"
          [labelName]="'Adres e-mail *'">
          <input
            type="email"
            class="fdx-c-form-group__input fdx-u-px--4"
            id="email"
            formControlName="email" />
        </app-form-input-control>

        <div class="fdx-o-grid__item--12 fdx-u-mt--10 fdx-u-mb--10">
          <app-form-header>
            Znajdź najbliższy punkt, do którego chcesz doręczyć przesyłkę. W
            polu WYSZUKAJ PUNKT wprowadź:<br />
            kod pocztowy, miejscowość, nazwę ulicy, sieci partnerskiej lub numer
            punktu.<br />
            W celu zawężenia wyszukiwania, możesz wskazać jednego lub wielu
            partnerów, klikając w ich logotyp.
          </app-form-header>
          <div
            class="fdx-u-mt--10"
            style="
              display: flex;
              flex-wrap: wrap;
              column-gap: 45px;
              row-gap: 40px;
              justify-content: center;
              align-items: center;
            ">
            <img
              *ngFor="let partner of partners"
              class="partner-logo"
              [src]="partner.image"
              [alt]="partner.name"
              [class.partner-logo_selected]="
                (selectedPartners$ | async)?.includes(partner.name)
              "
              (click)="toggleSelection(partner.name)" />
          </div>
        </div>

        <app-form-point-input-field
          class="fdx-o-grid__item--12"
          #childComponent
          [formField]="pointName"
          (selectedPoint)="onSelectedPoint($event)">
          <input
            type="text"
            class="fdx-c-form-group__input fdx-u-px--4"
            aria-describedby="alertID"
            aria-labelledby="ITEMLABEL"
            aria-autocomplete="list"
            aria-controls="ADDRESS-LIST"
            aria-activedescendant=""
            formControlName="pointName"
            autocomplete="off"
            (input)="onInputChanged($event, childComponent)"
            (focus)="onInputFocus(true, childComponent)"
            (blur)="onInputFocus(false, childComponent)" />
          <span class="fdx-c-form-group__suffix">
            <div class="fdx-o-grid__item--1">
              <button
                (mouseenter)="showTooltip()"
                (mouseleave)="hideTooltip()"
                class="fdx-c-button fdx-c-button--square-condensed fdx-c-button--primary fdx-u-border--none fdx-u-bg-color--purple fdx-u-color--white"
                style="height: 60px">
                <div class="fdx-c-button__icon" aria-hidden="true">?</div>
              </button>
              <div *ngIf="isTooltipVisible" class="fdx-c-tooltip__main">
                <div class="fdx-c-tooltip__main__body">
                  Wyszukaj punkt, do którego zostanie doręczona przesyłka.
                </div>
              </div>
            </div>
          </span>
        </app-form-point-input-field>

        <app-form-input-control
          class="fdx-o-grid__item--6"
          [formField]="pointId"
          [labelName]="'Numer'">
          <input
            type="text"
            class="fdx-c-form-group__input fdx-u-px--4"
            id="pointId"
            formControlName="pointId"
            [maxLength]="150" />
        </app-form-input-control>

        <app-form-input-control
          class="fdx-o-grid__item--6"
          [formField]="pointPartner"
          [labelName]="'Partner'">
          <input
            type="text"
            class="fdx-c-form-group__input fdx-u-px--4"
            id="pointPartner"
            formControlName="pointPartner"
            [maxLength]="150" />
        </app-form-input-control>

        <app-form-input-control
          class="fdx-o-grid__item--4"
          [formField]="pointZipCode"
          [labelName]="'Kod pocztowy'">
          <input
            type="text"
            class="fdx-c-form-group__input fdx-u-px--4"
            id="pointZipCode"
            formControlName="pointZipCode"
            [maxLength]="150" />
        </app-form-input-control>

        <app-form-input-control
          class="fdx-o-grid__item--4"
          [formField]="pointCity"
          [labelName]="'Miasto'">
          <input
            type="text"
            class="fdx-c-form-group__input fdx-u-px--4"
            id="pointCity"
            formControlName="pointCity"
            [maxLength]="150" />
        </app-form-input-control>

        <app-form-input-control
          class="fdx-o-grid__item--4"
          [formField]="pointAddress"
          [labelName]="'Adres'">
          <input
            type="text"
            class="fdx-c-form-group__input fdx-u-px--4"
            id="pointAddress"
            formControlName="pointAddress"
            [maxLength]="150" />
        </app-form-input-control>
      </div>
    </div>
  </div>

  <app-form-error-message
    [submitException]="submitException()"
    [form]="pointForm">
  </app-form-error-message>

  <div
    class="fdx-o-grid__row fdx-o-grid__row--center fdx-o-grid__row--guttered-small fdx-u-mb--5">
    <app-back-button
      [isLoading]="false"
      [isDisabled]="isSubmitLoading()"
      [buttonText]="'WSTECZ'"
      (clickEvent)="backButtonAction()">
    </app-back-button>
    <app-submit-button
      [isLoading]="isSubmitLoading()"
      [isDisabled]="pointForm.invalid"
      [buttonText]="'DALEJ'"
      (clickEvent)="onSubmit()"
      style="margin-left: 5px; margin-right: 2.5px">
    </app-submit-button>
  </div>
</form>
} @else {
<div>
  <app-form-header>
    Wybierając doręczenie do Punktu Partnerskiego FedEx, możesz nadać przesyłkę
    jednoelementową o maksymalnej wadze 20kg i wymiarach 50/40/30 cm. <br />Do
    Punktu Partnerskiego FedEx możesz nadać tylko paczkę.
  </app-form-header>
  <div
    class="fdx-o-grid__row fdx-o-grid__row--center fdx-o-grid__row--guttered-small fdx-u-mt--5 fdx-u-mb--5">
    <app-back-button
      [isLoading]="false"
      [isDisabled]="false"
      [buttonText]="'WSTECZ'"
      (clickEvent)="backButtonAction()">
    </app-back-button>
  </div>
</div>
}
